import request from '../tools/request'

// 获取部门树
export function deptTree () {
  return request({
    url: '/api/system/dept/tree',
    method: 'get'
  })
}

// 添加部门
export function deptAdd (body) {
  return request({
    url: '/api/system/dept/add',
    method: 'post',
    params: body
  })
}

// 修改部门
export function deptUpdate (body) {
  return request({
    url: '/api/system/dept/update',
    method: 'put',
    params: body
  })
}

// 删除部门--单个
export function delDept (body) {
  return request({
    url: '/api/system/dept/del',
    method: 'delete',
    params: body
  })
}

// 删除部门--批量
export function delDeptMore (body) {
  return request({
    url: '/api/system/dept/bathDelDept',
    method: 'delete',
    params: body
  })
}

// 搜索部门
export function deptList (body) {
  return request({
    url: '/api/system/dept/list',
    method: 'get',
    params: body
  })
}

// 部门详情
export function deptDetail (body) {
  return request({
    url: '/api/system/dept/detail',
    method: 'get',
    params: body
  })
}

// 获取角色树
export function roleTree () {
  return request({
    url: '/api/system/role/roleTreeList',
    method: 'get'
  })
}

// 新增角色
export function roleAdd (body) {
  return request({
    url: '/api/system/role/add',
    method: 'post',
    params: body
  })
}

// 修改角色
export function roleUpdate (body) {
  return request({
    url: '/api/system/role/update',
    method: 'put',
    params: body
  })
}

// 搜索角色
export function roleList (body) {
  return request({
    url: '/api/system/role/list',
    method: 'get',
    params: body
  })
}

// 删除角色--单个
export function delRole (body) {
  return request({
    url: '/api/system/role/del',
    method: 'delete',
    params: body
  })
}

// 删除角色--批量
export function delRoleMore (body) {
  return request({
    url: '/api/system/role/bathDelRole',
    method: 'delete',
    params: body
  })
}

// 搜索用户
export function userList (body) {
  return request({
    url: '/api/system/user/list',
    method: 'get',
    params: body
  })
}

// 新增用户
export function userAdd (body) {
  return request({
    url: '/api/system/user/add',
    method: 'post',
    params: body
  })
}

// 修改用户
export function userUpdate (body) {
  return request({
    url: '/api/system/user/update',
    method: 'put',
    params: body
  })
}

// 删除用户--单个
export function delUser (body) {
  return request({
    url: '/api/system/user/del',
    method: 'delete',
    params: body
  })
}

// 删除用户--批量
export function delUserMore (body) {
  return request({
    url: '/api/system/user/bathDelUser',
    method: 'delete',
    params: body
  })
}

// 冻结用户
export function freeze (body) {
  return request({
    url: '/api/system/user/freeze',
    method: 'post',
    params: body
  })
}

// 解除冻结用户
export function unfreeze (body) {
  return request({
    url: '/api/system/user/unfreeze',
    method: 'post',
    params: body
  })
}

// 重置用户密码
export function resetPassword (body) {
  return request({
    url: '/api/system/user/resetPassword',
    method: 'post',
    params: body
  })
}

// 修改用户密码
export function updatePassword (body) {
  return request({
    url: '/api/system/user/updatePassword',
    method: 'post',
    params: body
  })
}

// 分配角色
export function setRole (body) {
  return request({
    url: '/api/system/user/setRole',
    method: 'post',
    params: body
  })
}

// 获取菜单树
export function selectMenuTreeList () {
  return request({
    url: '/api/system/menu/selectMenuTreeList',
    method: 'get'
  })
}

// 搜索菜单
export function menuList (body) {
  return request({
    url: '/api/system/menu/list',
    method: 'get',
    params: body
  })
}

// 新增菜单
export function menuAdd (body) {
  return request({
    url: '/api/system/menu/add',
    method: 'post',
    params: body
  })
}

// 修改菜单
export function menuUpdate (body) {
  return request({
    url: '/api/system/menu/update',
    method: 'put',
    params: body
  })
}

// 删除菜单--单个
export function delMenu (body) {
  return request({
    url: '/api/system/menu/del',
    method: 'delete',
    params: body
  })
}

// 删除菜单--批量
export function delMenuMore (body) {
  return request({
    url: '/api/system/menu/bathDelMenu',
    method: 'delete',
    params: body
  })
}

// 获取角色对应的菜单权限
export function menuTreeListByRoleId (body) {
  return request({
    url: '/api/system/menu/menuTreeListByRoleId',
    method: 'get',
    params: body
  })
}

// 配置权限
export function setAuthority (body) {
  return request({
    url: '/api/system/role/setAuthority',
    method: 'post',
    params: body
  })
}



// WEBPACK FOOTER //
// ./src/api/system.js